import {Component} from "@angular/core";
import {TabsPageContainer} from "../../uiComponents/tabsPageContainer";

@Component({
	selector: 'inbound-configuration-tabs',
	templateUrl: './tools-tabs.component.html',
})
export class ToolsTabsComponent extends TabsPageContainer {
	tabWidth = 170;
}
